import { Button, DropDown } from "@finbeat/react-toolkit";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ClientBlockAdd } from "models/api/client";
import { useState } from "react";
import { useFieldArray } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from "reactstrap";
import ClientBlock from "./ClientBlock";
import { ClientBlocksFormType } from "./ClientBlocksModal";

type ClientBlocksFormProps = {
    actions: DropDown[];
    periods: DropDown[];
    reasons: DropDown[];
};

const ClientBlocksForm = ({ actions, periods, reasons }: ClientBlocksFormProps) => {
    const { t } = useTranslation();

    const { append, remove, fields } = useFieldArray<ClientBlocksFormType>({
        name: 'clientBlocks',
    });

    const [open, setOpen] = useState('');
    const toggleAccordion = (id: string) => {
        if (open === id) {
            setOpen('');
        } else {
            setOpen(id);
        }
    };

    const newBlock: () => ClientBlockAdd = () => ({
        action: actions[0]?.id?.toString() ?? '',
        adminComment: '',
        period: periods[0]?.id?.toString() ?? '',
        reasons: [{ name: reasons[0]?.id?.toString() ?? '', }],
        userComment: '',
    });

    const addBlock = () => {
        append(newBlock());
    };

    const deleteBlock = (idx: number) => {
        remove(idx);
    };

    const accordionProps = { toggle: toggleAccordion };
    const className = 'client-blocks-modal';

    return (
        <>
            <Accordion open={open} {...accordionProps}>
                {fields.map((_, idx) => (
                    <AccordionItem key={idx}>
                        <AccordionHeader
                            targetId={idx.toString()}
                            className={className + '-accordion-header'}
                        >
                            <Trans i18nKey="BackOfficeClientBlock" /> {idx + 1}
                            <Button
                                color="link"
                                className={
                                    className +
                                    '-accordion-header__remove text-danger px-3 hidden-child'
                                }
                                onClick={() => deleteBlock(idx)}
                            >
                                <FontAwesomeIcon
                                    role="button"
                                    icon={faTrashCan}
                                    title={t('BackOfficeDelete')}
                                />
                            </Button>
                        </AccordionHeader>
                        <AccordionBody accordionId={idx.toString()}>
                            <ClientBlock
                                index={idx}
                                actions={actions}
                                periods={periods}
                                reasons={reasons}
                            />
                        </AccordionBody>
                    </AccordionItem>
                ))}
            </Accordion>
            <div className={`d-flex mt-3 ${className}__add-block`}>
                <Button
                    color="secondary"
                    onClick={() => {
                        addBlock();
                    }}
                >
                    <Trans i18nKey="BackOfficeNewClientBlock" />
                </Button>
            </div>
        </>
    );
}

export default ClientBlocksForm;
